import styled from "styled-components";

const InputStyles = styled.div`
  .input {
    &:hover {
      border-color: #f3452e !important;
      box-shadow: 0 0 0 2px rgb(243 69 46 / 20%) !important;

      .inputIcon {
        color: #f3452e;
      }
    }
  }

  .activeInput {
    border-color: #f3452e !important;
    box-shadow: 0 0 0 2px rgb(243 69 46 / 20%) !important;

    .inputIcon {
      color: #f3452e;
    }
  }

  .select {
    div {
      &:hover {
        border-color: #f3452e !important;
        box-shadow: 0 0 0 2px rgb(243 69 46 / 20%) !important;

        .inputIcon {
          color: #f3452e;
        }
      }
    }
  }

  .activeSelect {
    div {
      border-color: #f3452e !important;
      box-shadow: 0 0 0 2px rgb(243 69 46 / 20%) !important;

      .inputIcon {
        color: #f3452e;
      }
    }
  }

  .inputIcon {
    color: #002f53;
  }
`;
export default InputStyles;
